<template>
  <v-col cols="12" md="3">
    <v-autocomplete
      clearable
      v-model="brand"
      :items="items"
      item-text="name"
      item-value="id"
      color="red darken-2"
      outlined
      class="field"
      :loading="loading"
      label="Brand (optional)"
      :search-input.sync="search"
    >
      <template v-slot:append-item>
        <div v-intersect="endIntersect" /> </template
    ></v-autocomplete>
    <ErrorInfo ref="ErrorInfo" />
  </v-col>
</template>

<script>
import EcuService from "../../../utils/services/ecu.service";
import ErrorInfo from "@/components/shared/ErrorInfo.vue";

export default {
  components: {
    ErrorInfo,
  },
  data: () => ({
    items: [],
    page: 1,
    maxPage: 1,
    brand: "",
    search: "",
    prevSearch: "",
    loading: false,
  }),
  watch: {
    async search() {
      setTimeout(() => this.onSearch(), 200);
    },
    brand() {
      this.$emit("brand", this.brand);
    },
  },
  async created() {
    this.page = 1;
    this.items = await this.initialize();
  },
  methods: {
    async onSearch() {
      if (this.search !== this.prevSearch) {
        this.prevSearch = this.search;
        this.page = 1;
        this.items = await this.initialize();
      }
    },
    async endIntersect(isIntersecting) {
      if (isIntersecting && this.items) {
        this.page += 1;
        let moreItems = await this.initialize();
        this.items = [...this.items, ...moreItems];
      }
    },
    async initialize() {
      if (this.page <= this.maxPage || this.maxPage === 0) {
        this.loading = true;
        return EcuService.getBrands(this.search, this.page)
          .then((response) => {
            this.maxPage = response.pagination.total_pages;
            return response.collection;
          })
          .catch(() => {
            this.$refs.ErrorInfo.catchError("Something goes wrong...");
            return this.items;
          })
          .finally(() => {
            this.loading = false;
          });
      } else return this.items;
    },
  },
};
</script>

